'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './news-edit.routes';

export class NewsEditComponent {
  /*@ngInject*/
  constructor(NewsService, Auth, $stateParams, $state, dialogs, $uibModal, StorageService, $location, Upload, $q, Config) {
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.NewsService = NewsService;
    this.StorageService = StorageService;
    this.toolbarDefinition = [
      ["bold","italics","underline","strikeThrough"],
      ["h3","h4","h5"],
      ["p","pre","quote","clear"],
      ["ul","ol"],
      ["justifyLeft","justifyCenter","justifyRight","justifyFull"],
      ["indent","outdent"],
      ["undo","redo"],
      ["codeMirror"],
      ["archiveImageLink", "insertImage", "insertLink"],
      ["backgroundColor","fontColor","fontName", "fontSize"]
    ];

    this.newsId = $stateParams.id;

    var newsConfig = Config.getModuleConfig(Config.Modules.News);

    this.newsType = newsConfig.getTypes();
    this.publicAllowed = newsConfig.getPublicAllowed();

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, this.type + " Edit");

    this.$state = $state;
    this.$location = $location;
    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.Upload = Upload;
    this.Auth = Auth;
    this.$q = $q;

    this.newsTemplate = {
      title: '',
      body: '',
      type: this.type,
      isFeatured: false,
      meta: {
        creationUser: Auth.getCurrentUserSync()._id,
        active: true
      }
    };

    /* Create Annoucement of Survey */
    if ($stateParams.surveyId && $stateParams.surveyName) {
      this.newsTemplate.title = "New Survey Available: " + $stateParams.surveyName;
      this.newsTemplate.body = `<p>Dear Residents, <br/>there is a new survey available: <b><i class="fa fa-fw fa-external-link-square"></i> <a href='/survey/${$stateParams.surveyId}'>${$stateParams.surveyName}</a></b></p>
        <p>We would appreciate if you find the time to participate in the survey.</p>
        <p>Thank you!</p>`;
      this.newsTemplate.isFeatured = true;
    }

    this.news = angular.copy(this.newsTemplate);
    this.assets = [];

    if (this.newsId) {
      this.NewsService.get({id: this.newsId}, data => {
        this.news = data;
        this.assets = data.attachments;
      }, err => {
        console.log('Could not load news from server');
      })
    }

    var that = this;

    this.dropHandler = function( file, insertAction ) {

        var isImage = that.isImageMime(file.type);
        var isPdf = that.isPdfMime(file.type);

        // validation
        if( !isImage && !isPdf) {
            // ignore other file than images and pdfs
            return;
        }

      /* could check for file size: if( file.size > 500000 ) */

      var defer = that.$q.defer();

        that.Upload.upload({
            url: '/api/storage',
            data: {
                name: file.name,
                file: file,
                storageStrategy: 'local',
                isPublic: true,
                creationUser: that.Auth.getCurrentUserSync()._id,
                active: true
            }
        }).then((response) => {

            if (isImage) {
              insertAction( "insertImage", "/api/storage/" + response.data, true );
              defer.resolve(true);
            } else if (isPdf) {
                that.StorageService.getMeta({id: response.data}, data => {
                    that.assets.push(data);
                    defer.resolve(true);
                }, err => {
                    console.log('could not retrieved storage from server');
                    defer.reject();
                });
            }

        }, (response) => {
            if (response.status > 0) {
                alert(response.status + ': ' + response.data);
                defer.reject();
            }
        });

      return defer.promise;

    };
  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }

  removeAsset(idx) {
    this.assets.splice(idx,1);
  }

  checkValidUntilDate(date) {
    if (new Date(date).getTime() < (new Date().getTime())) {
      return "The expiration date must not be in the past"
    }
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = data => {
        this.news = angular.copy(this.newsTemplate);
        this.submitted = false;

        var id = that.newsId || data._id;

        var actionString = (this.newsId) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "Your news post has been "+actionString+" successfully");
        dlg.result.then(() => {
          if (id) {
            that.$location.path("/"+this.type+"/" + id);
          } else {
            that.$state.go(this.type+"-news-list");
          }
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.news.attachments = this.assets.map(asset => {
        return asset._id;
      });

      if (this.newsId) {  // Save changes on the current news entry
        this.NewsService.update({id: this.newsId}, this.news, onSuccess, onError);
      } else { // Create a new news entry
        this.NewsService.save(this.news, onSuccess, onError);
      }
    }
  }

  openAssetBrowserModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetBrowser',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (newlySelectedAssets) {
        that.assets = that.assets.concat(newlySelectedAssets);
      },
      function () { /* cancel */ }
    );

  }

  openAssetUploadModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {
            acceptedFileTypes: 'application/pdf,image/*'
          }
        }
      }
    });

    modalInstance.result.then(
      function (result) {

        result.forEach(storageId => {
          that.StorageService.getMeta({id: storageId}, data => {
            that.assets.push(data);
          }, err => {
            console.log('could not retrieved storage from server');
          });

        });

      },
      function () { /* cancel */ }
    );

  }

}

export default angular.module('conduuApp.newsEdit', [uiRouter])
  .config(routes)
  .component('newsEdit', {
    template: require('./news-edit.html'),
    controller: NewsEditComponent,
    controllerAs: 'ctrl',
    bindings: {
      type: '@'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/news/edit/news-edit.component.js